var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1734932058947,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 3111,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234.688 576V138.688C234.688 97.408 268.096 64 309.312 64h405.376c41.216 0 74.624 33.408 74.624 74.688V576h96C926.592 576 960 609.408 960 650.688v192c0 41.216-33.408 74.624-74.688 74.624H138.688A74.688 74.688 0 0 1 64 842.688v-192C64 609.408 97.408 576 138.688 576h96zM400 234.688a37.312 37.312 0 0 0-37.312 37.312v10.688c0 20.608 16.64 37.312 37.312 37.312h224a37.312 37.312 0 0 0 37.312-37.312V272a37.312 37.312 0 0 0-37.312-37.312h-224z m0 170.624a37.312 37.312 0 0 0-37.312 37.376v10.624c0 20.608 16.64 37.376 37.312 37.376h224a37.312 37.312 0 0 0 37.312-37.376v-10.624a37.312 37.312 0 0 0-37.312-37.376h-224z",
    fill: "#ffffff",
    "p-id": 3112
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerate);
export default __webpack_public_path__ + "static/media/generate.e15c36919ac5cb796039dc513e99c917.svg";
export { ForwardRef as ReactComponent };